import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import { useIsFocused } from 'expo-router/react-navigation';
import { V2AContext } from 'features/v2a/sender/provider/V2AContextProvider';
import SearchRecipientScreen from 'features/v2a/sender/screens/SearchRecipientScreen/SearchRecipientScreen';
import TransferScreen from 'features/v2a/sender/screens/TransferScreen/TransferScreen';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import theme from 'shared/styles/theme';

const SendMoney = () => {
  const router = useRouter();
  const { selectedRecipient, setSelectedRecipient } = useContext(V2AContext);

  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'sender',
  });
  const { bottom } = useSafeAreaInsets();
  const isFocused = useIsFocused();

  const handleBackButtonPress = () => {
    if (selectedRecipient && isFocused) {
      setSelectedRecipient(undefined);
    } else {
      router.back();
    }
  };

  useBackHandler(handleBackButtonPress);

  return (
    <View style={[styles.mainContainer, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          gestureEnabled: false,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              options={{
                title: translatedText('v2aTransfer.title'),
                headerBackVisible: true,
              }}
              primaryOnPress={handleBackButtonPress}
            />
          ),
        }}
      />
      {selectedRecipient ? <TransferScreen /> : <SearchRecipientScreen />}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'space-between',
  },
});

export default SendMoney;
